import { render, staticRenderFns } from "./HeaderStyle.vue?vue&type=template&id=2fd0f15e&scoped=true"
import script from "./HeaderStyle.vue?vue&type=script&lang=js"
export * from "./HeaderStyle.vue?vue&type=script&lang=js"
import style0 from "./HeaderStyle.vue?vue&type=style&index=0&id=2fd0f15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0f15e",
  null
  
)

export default component.exports